import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Button, Divider, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Paper, Select, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { defaultApiCall, userSignUp } from '../../redux/Actions/userActions';
import { LoadingPage } from '../../common/LoadingPage';
import { showNotification } from '../../common/Notification/ToastifyNotification';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../common/common';

const DemoPaper = styled(Paper)(({ theme }) => ({
    width: 550,
    height: 'auto',
    padding: '0px 0px 25px 0px',
    margin: 'auto',
    border: '1px solid lightgray'
}));

export default function SignUp() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, message, error } = useSelector((state) => state.users);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [organizationName, setOrganizationName] = useState(null);
    const [organizationType, setOrganizationType] = useState(null);
    const [orgWebsite, setOrgWebsite] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [organizationData, setOrganizationData] = useState([]);
    const [organizationId, setOrganizationId] = useState(null);

    const handleRegister = () => {
        const newErrors = {};
        if (!firstName) {
            newErrors.firstName = 'First Name is required';
        }
        if (!email) {
            newErrors.email = 'Email is required';
        }
        if (!organizationName && !organizationId) {
            newErrors.organizationName = 'Organization Name is required';
            newErrors.organization = 'Please Select Organization';
        }
        if (!organizationType && !organizationId) {
            newErrors.organizationType = 'Organization Type is required';
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            const data = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneNumber: phone,
                organizationName: organizationName,
                orgType: organizationType,
                orgWebsite: orgWebsite,
                organizationId: organizationId
            }
            dispatch(userSignUp(data));
        }
    }

    useEffect(() => {
        if (message) {
            setFirstName('');
            setLastName('');
            setEmail('');
            setPhone('');
            setOrganizationName('');
            setOrganizationType('');
            setOrgWebsite('');
            setErrors({});
            showNotification(message, 'success');
            dispatch(defaultApiCall());
            navigate('/');
        }
        if (error) {
            showNotification(error, 'error');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, message]);

    const getOrganizations = async () => {
        try {
            setDataLoading(true);
            const response = await apiRequest('get', '/organization-list');
            if (response?.data) {
                const { data } = response?.data;
                setOrganizationData(data);
                setDataLoading(false);
            }
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        getOrganizations();
    }, []);

    return (
        <>
            {(loading || dataLoading) && (<LoadingPage isLoading={loading || dataLoading} />)}
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
                <Grid item xs={12} md={6}>
                    <DemoPaper variant="elevation">
                        <Box style={{ display: 'flex', justifyContent: 'end', padding: '10px 0px' }}>
                            <img src="/images/Logo.png" alt='logo' style={{ width: '30%' }} />
                        </Box>
                        <Divider />
                        <Grid container pl={2} pr={2} spacing={2} mt={1}>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">First Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="First Name"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={firstName}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.firstName = '';
                                            } else {
                                                newErrors.firstName = 'First Name is required'
                                            }
                                            setErrors(newErrors);
                                            setFirstName(e.target.value)
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.firstName}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Last Name</InputLabel>
                                    <OutlinedInput
                                        label="Last Name"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Email <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="Email"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={email}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (!e.target.value) {
                                                newErrors.email = 'Email is required';
                                            } else if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                                                newErrors.email = 'Email is invalid';
                                            } else {
                                                newErrors.email = '';
                                            }
                                            setErrors(newErrors);
                                            setEmail(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Phone Number</InputLabel>
                                    <OutlinedInput
                                        label="Phone Number"
                                        id="standard-adornment-password"
                                        type='number'
                                        value={phone}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            setPhone(e.target.value)
                                            const phoneRegex = /^(?:\+?(\d{1,2}))?[-.\s]?(\(?\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;
                                            if (phoneRegex.test(e.target.value)) {
                                                newErrors.phoneNumber = '';
                                            } else if (!e.target.value) {
                                                newErrors.phoneNumber = '';
                                            } else {
                                                newErrors.phoneNumber = 'Please provide valid phone number';
                                            }
                                            setErrors(newErrors);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.keyCode === 38 || event.keyCode === 40) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.phoneNumber}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <Autocomplete
                                    value={organizationData.find((c) => c.organization_id === organizationId) || null}
                                    id="combo-box-demo"
                                    size="small"
                                    fullWidth
                                    options={organizationData}
                                    getOptionLabel={(option) => option.org_name}
                                    onChange={(event, newValue) => {
                                        setOrganizationId(newValue?.organization_id || null);
                                        const newErrors = errors;
                                        if (newValue?.organization_id) {
                                            newErrors.organization = '';
                                        } else {
                                            newErrors.organization = 'Please Select Organization';
                                        }
                                        newErrors.organizationName = '';
                                        newErrors.organizationType = '';
                                        setErrors(newErrors);
                                    }}
                                    renderInput={(params) => <TextField fullWidth {...params} label="Select Organization" name="Select Organization" variant="outlined" />}
                                />
                                <Typography variant='body2' style={{ color: 'red' }}>{errors.organization}</Typography>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <Typography variant='body1' sx={{ textAlign: 'center' }}>OR</Typography>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Name</InputLabel>
                                    <OutlinedInput
                                        label="Organization Name"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={organizationName}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.organization = '';
                                                newErrors.organizationName = '';
                                            } else {
                                                newErrors.organizationName = 'Organization Name is required'
                                            }
                                            setErrors(newErrors);
                                            setOrganizationName(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.organizationName}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        label="Organization Type"
                                        value={organizationType}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.organization = '';
                                                newErrors.organizationType = '';
                                            } else {
                                                newErrors.organizationType = 'Organization Type is required'
                                            }
                                            setErrors(newErrors);
                                            setOrganizationType(e.target.value);
                                        }}
                                    >
                                        <MenuItem value="hospital">Hospital</MenuItem>
                                        <MenuItem value="facilitator">facilitator</MenuItem>
                                        <MenuItem value="architect">Architect</MenuItem>
                                        <MenuItem value="planner">Planner</MenuItem>
                                        <MenuItem value="trust">Trust</MenuItem>
                                        <MenuItem value="government">Government</MenuItem>
                                    </Select>
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.organizationType}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Website</InputLabel>
                                    <OutlinedInput
                                        label="Organization Website"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={orgWebsite}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/;
                                            if (websiteRegex.test(e.target.value)) {
                                                newErrors.orgWebsite = '';
                                            } else if (!e.target.value) {
                                                newErrors.orgWebsite = '';
                                            } else {
                                                newErrors.orgWebsite = 'Please provide valid website';
                                            }
                                            setErrors(newErrors);
                                            setOrgWebsite(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.orgWebsite}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <center>
                                    <Button
                                        color='primary'
                                        size="Medium"
                                        variant='contained'
                                        onClick={() => {
                                            handleRegister();
                                        }}
                                    >
                                        Register
                                    </Button>
                                </center>
                            </Grid>
                        </Grid>
                    </DemoPaper>
                </Grid>
            </Grid>
        </>
    );
}